import React from 'react';
import { useIntl } from 'react-intl';
import { Evidence, useDictionaryEvidence } from '@eas/common-web';
import { ExportTags } from '../../../common/export-tags';
import { OrganisationType } from '../../../common/models';
import { initNewDisabledItem } from '../../../utils/dictionary-item';
import { useValidationSchema } from './organisation-types-schema';

export function OperatorOrganisationTypes() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();

  const evidence = useDictionaryEvidence<OrganisationType>({
    identifier: 'ORGANISATION_TYPES',
    apiProps: {
      url: '/api/ks/organisation-types',
    },
    tableProps: {
      tableName: intl.formatMessage({
        id: 'KS_O_ORGANISATION_TYPES_TABLE_TITLE',
        defaultMessage: 'Typy organizací',
      }),
      reportTag: ExportTags.ORGANISATION_TYPE_GRID,
    },
    detailProps: {
      validationSchema,
      initNewItem: initNewDisabledItem,
    },
  });

  return <Evidence {...evidence} />;
}
